import { render, staticRenderFns } from "./registry_breadcrumb.vue.js?vue&type=template&id=5ea88f1d!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registry_breadcrumb.vue?vue&type=template&id=5ea88f1d"
import script from "./registry_breadcrumb.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registry_breadcrumb.vue?vue&type=script&lang=js"
export * from "./registry_breadcrumb.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registry_breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports